import { t } from "../../i18n";
import { useChatMentions } from "./ChatMentionsContext";
import { Markdown } from "../Markdown";
import { ArtifactCard } from "../artifacts/ArtifactCard";
import { FileTab } from "../game-assets/FileTab";
export function ChatMentionDetails({
  conversationId,
}: {
  conversationId: string;
}) {
  const context = useChatMentions();
  const selected = context?.selected;
  if (!selected) return null;
  const reference = selected.reference;
  if (reference.startsWith("/")) {
    const skill = [...context.skills]
      .reverse()
      .find((row) => `/${row.slug}` === reference);
    return (
      <div className="p-4">
        <h3 className="mb-2 font-semibold">{skill?.name ?? reference}</h3>
        {skill ? (
          <>
            <p className="mb-4 text-sm text-stone-500">{skill.description}</p>
            <Markdown>{skill.instructions ?? ""}</Markdown>
          </>
        ) : (
          <p role="status">{t("Skill is no longer available.")}</p>
        )}
      </div>
    );
  }
  if (reference.startsWith("@artifact:")) {
    const artifact = context.artifacts.find(
      (row) => `@artifact:${row.id}` === reference,
    );
    return (
      <div className="p-4">
        {artifact ? (
          <ArtifactCard artifact={{ ...artifact }} featured />
        ) : (
          <p role="status">{t("Artifact is no longer available.")}</p>
        )}
      </div>
    );
  }
  return (
    <FileTab
      key={`${reference}:${selected.selection.workspaceId}:${selected.selection.repositoryId}`}
      conversationId={conversationId}
      selection={selected.selection}
      path={reference.slice(1)}
      initialMode="file"
    />
  );
}
